import Color from 'color';
import { lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import {
  activityLogsPanelMobileHeight,
  LEFT_SIDE_PANEL_MOTION_MS,
  leftSidePanelMotionEase,
  logRes1,
} from 'pages/styles';
import styled from 'styled-components';

const ink = '#1a1a1a';
const line = Color('#e5e7eb').darken(0.02).toString();

export const scrollBarRes = '1150px';
export const Container = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  z-index: 1;
  @media(max-width: ${logRes1}) {
    flex-direction: column;
  }
`;

export const ActivityLogsPanelMobile = styled.div<{ $hidden?: boolean }>`
  display: none;
  width: 100%;
  height: ${activityLogsPanelMobileHeight};
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 15;
  background: #fff;
  border-bottom: 1px solid ${line};
  box-shadow: 0 4px 12px rgba(17, 24, 39, 0.04);
  padding: 10px 14px;
  gap: 10px;
  overflow: hidden;
  transition:
    height ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    padding ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    opacity 220ms ${leftSidePanelMotionEase},
    box-shadow ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    border-color 220ms ${leftSidePanelMotionEase};
  ${({ $hidden }) => ($hidden ? `
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
    pointer-events: none;
    box-shadow: none;
    border-bottom-color: transparent;
  ` : '')}
  @media(max-width: ${logRes1}) {
    display: flex;
    align-items: center;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ActivityLogsText = styled.div`
  flex-shrink: 0;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${ink};
  line-height: 1;
  padding-right: 10px;
  margin-right: 2px;
  border-right: 1px solid ${Color(lFColor0).alpha(0.18).toString()};
`;

/** /logs table / search prompt / in-page loader. */
export const RightPane = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
